import { Text } from '@consta/uikit/Text'
import type { TextFieldProps } from '@consta/uikit/TextField'
import { TextField } from '@consta/uikit/TextField'
import cn from 'classnames'
import type { FC } from 'react'

import css from './MapBuildingRightMenu.css'
import type { XYTextFieldProps } from './types'

const textFieldProps: TextFieldProps<string> = {
  size: 'xs',
  className: css.geometryMenuTextFields,
}

export const XYTextFields: FC<XYTextFieldProps> = ({
  labelsArray,
  disabledProps,
  data,
  isValid,
  onChangeGeometry,
}) => {
  const [firstText, secondText, thirdText] = labelsArray
  const textFieldType = disabledProps.disabled ? '' : 'number'

  return (
    <>
      <div className={css.menuFields}>
        <Text className={css.textPadding} size="xs" view="secondary">
          {firstText}
        </Text>
        <TextField
          type={textFieldType}
          min={0}
          className={css.geometryMenuTextFields}
          size="xs"
          name={data.min.name}
          withClearButton={!disabledProps.disabled}
          value={String(data.min.value)}
          status={!isValid ? 'alert' : undefined}
          onChange={value => {
            onChangeGeometry({ name: data.min.name, value })
          }}
          {...disabledProps}
        />
      </div>
      <div className={css.menuFields}>
        <Text className={css.textPadding} size="xs" view="secondary">
          {secondText}
        </Text>
        <TextField
          type={textFieldType}
          min={0}
          withClearButton={!disabledProps.disabled}
          name={data.max.name}
          value={String(data.max.value)}
          status={!isValid ? 'alert' : undefined}
          onChange={value => {
            onChangeGeometry({ name: data.max.name, value })
          }}
          {...textFieldProps}
          {...disabledProps}
        />
      </div>
      <div className={cn(css.menuFields, css.thirdTextWrapper)}>
        <Text size="xs" view="secondary" className={css.textPadding}>
          {thirdText}
        </Text>
        <TextField type={textFieldType} min={0} {...textFieldProps} {...disabledProps} />
      </div>
    </>
  )
}
